import { CenteredLoader } from '@library/components'
import type { FC, PropsWithChildren } from 'react'
import { Suspense } from 'react'

import { ErrorBoundary, TabErrorElement } from '../utils'

export const TabWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ErrorBoundary ErrorComponent={TabErrorElement}>
      <Suspense fallback={<CenteredLoader />}>{children}</Suspense>
    </ErrorBoundary>
  )
}
